<template>
	<div>
		<pui-modal-dialog-form
			:titleText="$t('puiaction.docgen.uploadnewtemplate')"
			:modelName="modelName"
			:dialogName="dialogNameUploadNewTemplate"
			:widthDialog="800"
			:onOk="onOkUploadNewTemplate"
		>
			<template slot="message">
				<v-layout wrap class="justify-center">
					<v-flex xs12 md8 xl9>
						<pui-text-field :label="$t('puidocgentemplate.filename')" v-model="fileName" toplabel required disabled></pui-text-field>
						<input v-show="false" type="file" accept=".doc, .docx, .odt" ref="document" @change="onFilePicked" />
					</v-flex>
					<v-flex xs12 md4 xl3>
						<v-btn color="primary" @click="pickFile" style="margin-top: 20px">{{ $t('puidocgentemplate.selectfile') }}</v-btn>
					</v-flex>
				</v-layout>
			</template>
		</pui-modal-dialog-form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			dialogNameUploadNewTemplate: 'uploadNewTemplate',
			fileTypes: {
				'application/msword': 'fas fa-file-word',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'fas fa-file-word',
				'application/vnd.oasis.opendocument.text': 'fas fa-file-word'
			},
			fileName: null,
			selectedFile: null,
			selectedFileType: null
		};
	},
	props: {
		modelName: {
			required: true,
			type: String
		}
	},
	methods: {
		pickFile() {
			this.$refs.document.click();
		},
		onFilePicked(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				const file = files[0];
				if (file.name.lastIndexOf('.') <= 0) {
					return;
				}

				this.fileName = file.name;
				const fr = new window.FileReader();
				fr.addEventListener('load', () => {
					this.selectedFile = file; // this is the file that can be sent to server...
					this.selectedFileType = this.fileTypes[file.type];
				});
				fr.readAsDataURL(file);
			} else {
				this.fileName = null;
				this.selectedFile = null;
				this.selectedFileType = null;
			}
		},
		onOkUploadNewTemplate(modalData) {
			const formData = new window.FormData();
			formData.append('id', modalData.id);
			formData.append('file', this.selectedFile, this.selectedFile.name);
			formData.append('filename', this.selectedFile.name);

			const urlController = this.$store.getters.getModelByName(this.modelName).url.uploadTemplate;
			const title = this.$puiI18n.t('puiaction.notifyTitle') + ' > ' + this.$puiI18n.t('puiaction.docgen.uploadnewtemplate');
			return new Promise((resolve) => {
				this.$puiRequests.uploadFileRequest(
					urlController,
					formData,
					(response) => {
						if (response.status === 200) {
							this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
							const message = this.$puiI18n.t('puiaction.notifySuccess');
							this.$puiNotify.success(message, title);
							resolve(true);
						} else {
							let message = this.$puiI18n.t('puiaction.notifyError');
							if (response.data) {
								message = response.data.message;
							}
							this.$puiNotify.error(message, title);
							resolve(false);
						}
					},
					(error) => {
						this.$puiEvents.$emit('onPui-action-running-ended-' + this.modelName);
						let message = this.$puiI18n.t('puiaction.notifyError');
						if (error.response && error.response.data) {
							message = error.response.data.message;
						}
						this.$puiNotify.error(message, title);
						resolve(false);
					}
				);
			});
		}
	}
};
</script>
